import { FC, useContext } from 'react'
import { HistoryContext } from '../../contexts/HistoryContext'
import BidButton from '../../elements/BidButton/BidButton'

const BackToItemList: FC<BackToItemListProps> = ({
  auctionId,
  itemId,
  pageNumber,
  showBackToSaveSearch = true,
}) => {
  const history: any = useContext(HistoryContext)
  const prevUrl = history?.path?.prev || ''

  const getUrl = () => {
    if (!prevUrl) return `/auction-detail/${auctionId}/${pageNumber}`
    if (
      prevUrl.includes(`/auction-detail/${auctionId}`) ||
      prevUrl.includes('saved-search')
    )
      return prevUrl.includes('?')
        ? `${prevUrl}&itemId=${itemId}`
        : `${prevUrl}?itemId=${itemId}`

    return `/auction-detail/${auctionId}/${pageNumber}`
  }

  const url = getUrl()

  return (
    <div className="flex flex-col gap-2 w-full">
      <BidButton
        link={url}
        label={'See All Items In Auction'}
        theme="blue-light"
        type="link"
        width="full"
        hasLeftArrow
        className={'px-2 py-2 tracking-tighter'}
      />
      {showBackToSaveSearch && prevUrl.includes('/items?') ? (
        <BidButton
          link={prevUrl}
          label={'Back to Item Search'}
          theme="blue-light"
          type="link"
          width="full"
          hasLeftArrow
          className={'px-2 py-2'}
        />
      ) : (
        <></>
      )}
    </div>
  )
}

type BackToItemListProps = {
  pageNumber: number
  auctionId: number
  itemId: number
  showBackToSaveSearch?: boolean
}

export default BackToItemList
